import { useEffect, useState } from "react";
import { getDownloadURL, listAll, ref } from "firebase/storage";
import { collection, getDocs } from "firebase/firestore";
import { db, storage } from "../firebase";

const useDoctors = () => {
  const [images, setImages] = useState({
    doctorImage: "",
    iconicImage: "",
    appointmentImage: "",
  });
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch doctor images from Firebase Storage
  useEffect(() => {
    const fetchImages = async () => {
      try {
        const homeRef = ref(storage, "doctordetails");
        const listResult = await listAll(homeRef);
        const urls = await Promise.all(
          listResult.items.map((item) => getDownloadURL(item))
        );
        setImages({
          doctorImage: urls.find((url) => url.includes("doctorImage")),
          iconicImage: urls.find((url) => url.includes("iconic")),
          appointmentImage: urls.find((url) => url.includes("appointment")),
        });
      } catch (error) {
        console.error("Error fetching images: ", error);
      }
    };

    fetchImages();
  }, []);

  // Fetch doctors (users) from Firestore
  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "Users"));
        const doctorsList = querySnapshot.docs.map((doc) => doc.data());
        setDoctors(doctorsList);
      } catch (error) {
        console.error("Error fetching doctors: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDoctors();
  }, []);

  // Utility to fetch the proper translation with fallback
  const getTranslatedValue = (field, lang) => {
    if (!field) return "";
    return field[lang] || field["en"] || "";
  };

  return { images, doctors, loading, getTranslatedValue };
};

export default useDoctors;
